import { state } from '@/store/rfid/state';
import { getters } from '@/store/rfid/getters';
import { actions } from '@/store/rfid/actions';
import { mutations } from '@/store/rfid/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
